import { z } from 'zod';
import { QualityRatingSchema } from './business-managers';

/**
 * Status diário de envios por phone_number_id de uma connection.
 * Usado pra UI "Envios hoje" em /connections/:id mostrar governança ativa
 * (daily cap + janela 8h-18h BR + quality rating-aware).
 *
 * Reusa `QualityRatingSchema` de business-managers (mesmo enum
 * GREEN/YELLOW/RED/UNKNOWN).
 */

export const PhoneTodayCountSchema = z.object({
  phoneNumberId: z.string(),
  sentToday: z.number().int().nonnegative(),
  cap: z.number().int().nonnegative(),
  hasSlot: z.boolean(),
  sentPct: z.number().min(0).max(100),
  qualityRating: QualityRatingSchema,
});
export type PhoneTodayCount = z.infer<typeof PhoneTodayCountSchema>;

export const ConnectionTodayCountsResponseSchema = z.object({
  /** ISO date YYYY-MM-DD do "dia operacional" sendo medido (UTC). */
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  /** Default cap aplicado (200/dia salvo override per-connection). */
  cap: z.number().int().nonnegative(),
  /** Se a janela horária BR (default 8h-18h) está aberta agora. */
  windowOpen: z.boolean(),
  /** Hora atual em BR (UTC-3) — pra UI mostrar "fora da janela: 21h BR". */
  currentBrHour: z.number().int().min(0).max(23),
  phones: z.array(PhoneTodayCountSchema),
});
export type ConnectionTodayCountsResponse = z.infer<typeof ConnectionTodayCountsResponseSchema>;
